import { qs, toggle, listen, add } from '@fluorescent/dom';

import { section } from '@/glow';

const selectors = {
  trigger: '[data-trigger]',
  errors: '.errors',
};

section('password', {
  onLoad() {
    const trigger = qs(selectors.trigger, this.container);
    const containsErrors = qs(selectors.errors, this.container);

    this.events = [
      listen(trigger, 'click', () =>
        toggle(this.container, 'password--show-login')
      ),
    ];

    if (containsErrors) {
      add(this.container, 'password--show-login');
    }
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
